import { ErrorHandler, Injectable } from '@angular/core';

const CLAVE_RECARGA_CHUNK = 'sop_ultima_recarga_chunk';
const TIEMPO_LIMITE_RECARGA_MS = 15000; // 15 segundos para evitar bucles si hay problemas de conectividad

/**
 * Manejador global de errores para detectar fallos de descarga de módulos diferidos (ChunkLoadError).
 * Ocurre cuando se despliega una nueva versión con nuevos hashes y un usuario con la app abierta
 * intenta navegar a una ruta cuyo archivo JavaScript anterior ya fue reemplazado en el servidor.
 */
@Injectable()
export class ManejadorErrorChunkUtil implements ErrorHandler {
  handleError(error: unknown): void {
    const errorCasteado = error as { message?: string } | null;
    const mensaje = errorCasteado?.message || (typeof error === 'string' ? error : '') || '';

    const esErrorChunk =
      /loading chunk/i.test(mensaje) ||
      /failed to fetch dynamically imported module/i.test(mensaje) ||
      /importing a module script failed/i.test(mensaje) ||
      /error loading dynamically imported module/i.test(mensaje);

    if (esErrorChunk && typeof window !== 'undefined') {
      const ultimaRecarga = sessionStorage.getItem(CLAVE_RECARGA_CHUNK);
      const ahora = Date.now();

      if (!ultimaRecarga || ahora - Number(ultimaRecarga) > TIEMPO_LIMITE_RECARGA_MS) {
        sessionStorage.setItem(CLAVE_RECARGA_CHUNK, ahora.toString());
        console.warn(
          '[ManejadorErrorChunk] Detectado módulo desactualizado por nuevo despliegue. Recargando aplicación...',
        );
        window.location.reload();
        return;
      }
    }

    console.error(error);
  }
}
